import { Injectable } from '@angular/core';

import { MessageService } from '../../services';
import { BaseEntity } from '../../../models';
import { BaseVisualizacaoSubCadastro } from '../base-visualizacao-sub-cadastro';

@Injectable({
    providedIn: 'root'
})
export class BaseVisualizacaoSubCadastroService {

    constructor(private messageService: MessageService) { }

    /** Abre o formulário do sub cadastro */
    openForm(visualizacao: BaseVisualizacaoSubCadastro<BaseEntity>) {
        visualizacao.isFormOpen = true;
    }

    /** Fecha o formulário do sub cadastro */
    closeForm(visualizacao: BaseVisualizacaoSubCadastro<BaseEntity>) {
        visualizacao.isFormOpen = false;
        visualizacao.showTable();
    }

    /** Insert padrão dos sub cadastros */
    insert(visualizacao: BaseVisualizacaoSubCadastro<BaseEntity>) {
        visualizacao.openForm();
        visualizacao.form.insert();
    }

    /** Edit padrão dos sub cadastros */
    edit(visualizacao: BaseVisualizacaoSubCadastro<BaseEntity>, index: number) {
        visualizacao.openForm();
        visualizacao.form.edit(index);
    }

    /** Delete padrão dos sub cadastro */
    delete<T extends BaseEntity>(visualizacao: BaseVisualizacaoSubCadastro<BaseEntity>, entityIndex: number, entities: T[], messageConfirm = 'Deseja realmente excluir esse registro?'): Promise<any> {
        return new Promise<void>((resolve, reject) => {
            this.messageService.confirm(messageConfirm).then(result => {
                if (result) {
                    entities.splice(entityIndex, 1);
                    visualizacao.showTable();
                    resolve();
                } else {
                    reject();
                }
            });
        })
    }


}
